export const AuthTab = {
  Phone: 'phone',
  Email: 'email',
} as const
export type AuthTab = (typeof AuthTab)[keyof typeof AuthTab]
